import React, { useState } from 'react';

import type { LunaError } from '@vlabs/api-bindings/src/luna-client/LunaError';
import type { LoginFormValues } from '@vlabs/monokit/entities/auth';
import { LoginForm } from '@vlabs/monokit/entities/auth';
import { Page, PageContent } from '@vlabs/monokit/shared/ui/page';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';

import { initApp } from '@vlapps/luna/src/app/store/appSlice.js';

import { useLoginPageTranslation } from './i18n';
import st from './LoginPage.module.sass';
import { login as auth } from './store';

interface LoginPageProps {
  CustomBrand?: React.ReactNode;
}

function LoginPage({
  CustomBrand = undefined,
}: LoginPageProps): React.JSX.Element {
  const { t } = useLoginPageTranslation();
  const dispatch = useDispatch();
  const [error, setError] = useState<string>();

  const onSubmit = async ({ login, password }: LoginFormValues) => {
    try {
      await dispatch(auth({ login, password }));
      dispatch(initApp);
    } catch (e) {
      if ((e as LunaError).status) {
        if (e.status === 401) {
          setError(t('error.login_or_password_is_wrong') ?? undefined);
        } else if (e.status === 403) {
          setError(t('error.user_is_blocked'));
        }
      }
    }
  };

  return (
    <Page>
      <PageContent className={st.Root}>
        {!!CustomBrand && <div className={st.Brand}>{CustomBrand}</div>}
        <div className={classNames(st.Wrapper, { [st.Error]: error })}>
          <LoginForm
            error={error}
            onSubmit={onSubmit}
          />
        </div>
      </PageContent>
    </Page>
  );

  // return (
  //   <Pages.LoginPage
  //     CustomBrand={CustomBrand ? <CustomBrand className="FormPage__Logo" /> : undefined}
  //     error={error}
  //     onSubmit={loginHandler}
  //     useEmailAsLogin
  //   />
  // );
}

export { LoginPage };
